import React from 'react';
import { motion } from "framer-motion";
import { Button } from '@headlessui/react';
import { useNavigate } from 'react-router-dom';


export default function JoinInvitedUser() {

    // const { completeInviteAcceptance } = useAuth();
    const navigate=useNavigate();

  const handleLogin = async () => {
    // 
    navigate("/login", { replace: true });

  };

  return (
    <div className="bg-primary rounded-2xl border shadow-lg  border-[#222735] w-full pt-[50px] pb-[40px] px-4">
        <div className='text-center'>
         <motion.img
          src="/assets/worklap-white-logo.svg"
          className="mx-auto"
          alt="Worklap Logo"
          animate={{ rotate: 360 }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "linear",
          }}
        />
        <h1 className='mt-4 font-semibold'>
            Account created successfully!
        </h1>
        <p className='mt-2 text-sm italic text-neutral-medium'>
            Your Worklap account is ready. Log in to access your organization workspace.
        </p>
        <div className="grid mx-auto gap-4 mt-9 max-w-[350px] ">
            <Button
            onClick={handleLogin}
                className="bg-[#181C27] border border-[#232941] h-[46px] rounded-lg flex justify-center gap-3 items-center"
            >
             Log In
            </Button>

        </div>
        </div>
    </div>
  )
};